import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import isFuture from 'date-fns/isFuture';

@Component({
	selector: 'app-treefort-promotion-banner',
	templateUrl: './treefort-promotion-banner.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TreefortPromotionBannerComponent {
	public LIGHT_BULB_ICON = ICON.LIGHT_BULB;
}
